module.exports = __webpack_public_path__ + "img/second-world-bg.c6004c88.png";